import React from 'react';
import Svg, { Line } from 'react-native-svg';
const CloseIcon = ({ style }) => (<Svg viewBox="0 0 20 20" style={style}>
    <Line x1={1} y1={1} x2={19} y2={19} stroke="#fff" strokeWidth={4} strokeLinecap="round"/>
    <Line x1={1} y1={19} x2={19} y2={1} stroke="#fff" strokeWidth={4} strokeLinecap="round"/>
  </Svg>);
export default CloseIcon;
